// extracted by mini-css-extract-plugin
export default {"tweetLayout":"adminMainSection_tweetLayout__hAh52","userLayout":"adminMainSection_userLayout__OMlM4","userListContainer":"adminMainSection_userListContainer__rLYWx"};